
import { useScrollReveal } from '../../../hooks/useScrollReveal';

const differentiators = [
  { label: 'Audit-led methodology', icon: 'ri-search-eye-line' },
  { label: 'Platform-agnostic recommendations', icon: 'ri-equalizer-line' },
  { label: 'ROI-first prioritization', icon: 'ri-line-chart-line' },
  { label: 'Governance and risk consideration', icon: 'ri-shield-check-line' },
  { label: 'Built for executive leadership teams', icon: 'ri-team-line' },
];

export default function WhatMakesDifferent() {
  const { ref: headerRef, isVisible: headerVisible } = useScrollReveal(0.2);
  const { ref: gridRef, isVisible: gridVisible } = useScrollReveal(0.1);
  const { ref: imageRef, isVisible: imageVisible } = useScrollReveal(0.15);

  return (
    <section className="py-32 md:py-40 bg-[#0B0D10] relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div ref={headerRef} className={`text-center mb-20 transition-all duration-1000 ${headerVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <p className="text-sm tracking-[0.25em] uppercase text-[#3A5F8C] mb-4 font-medium">Our Difference</p>
          <h2 className="text-4xl md:text-5xl lg:text-[56px] font-bold text-[#F5F7FA] tracking-tight leading-[1.1] mb-6">
            Advisors First.<br />Technologists Second.
          </h2>
          <p className="text-lg text-[#F5F7FA]/50 max-w-2xl mx-auto">
            We do not sell tools. We solve business problems.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div ref={gridRef} className="space-y-4">
            {differentiators.map((item, index) => (
              <div
                key={index}
                className={`flex items-center gap-5 p-5 rounded-xl bg-[#2A2E35]/30 hover:bg-[#2A2E35]/60 transition-all duration-500 cursor-default group ${gridVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-8'}`}
                style={{ transitionDelay: gridVisible ? `${index * 80}ms` : '0ms' }}
              >
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-[#3A5F8C]/20 group-hover:bg-[#3A5F8C]/30 transition-colors">
                  <i className={`${item.icon} text-lg text-[#3A5F8C]`}></i>
                </div>
                <p className="text-base text-[#F5F7FA]/80 font-medium group-hover:text-[#F5F7FA] transition-colors">
                  {item.label}
                </p>
              </div>
            ))}
          </div>

          <div ref={imageRef} className={`relative w-full h-[520px] rounded-2xl overflow-hidden transition-all duration-1000 delay-200 ${imageVisible ? 'opacity-100 scale-100' : 'opacity-0 scale-95'}`}>
            <img
              src="https://public.readdy.ai/ai/img_res/ac0e01ee12b4426fd026c4edb2cc5ebd.jpg"
              alt="Precision advisory"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0B0D10] via-transparent to-transparent opacity-60"></div>
          </div>
        </div>
      </div>
    </section>
  );
}
